export enum Locales {
    EN = 'en',
    DE = 'de',
    SE = 'se',
    NO = 'no',
    FI = 'fi',
    FR = 'fr',
    CS = 'cs',
    PL = 'pl',
    NL = 'nl',
    IT = 'it',
    ES = 'es',
    HU = 'hu',
    PT = 'pt',
    RU = 'ru',
    JA = 'ja',
    TH = 'th',
    ID = 'id',
}

export const LOCALES = [
    { value: Locales.EN, caption: 'English' },
    { value: Locales.SE, caption: 'Swedish - svenska' },
    { value: Locales.DE, caption: 'German - Deutsch' },
    // { value: Locales.NO, caption: 'Norwegien - norsk' },
    // { value: Locales.FI, caption: 'Finnish - norsk' },
    { value: Locales.FR, caption: 'French - français'},
    { value: Locales.PL, caption: 'Polish - polski'},
    // { value: Locales.NL, caption: 'Dutch - Nederlands'},
    { value: Locales.IT, caption: 'Italian - italiano'},
    { value: Locales.ES, caption: 'Spanish - español'},
    // { value: Locales.HU, caption: 'Hungarian - magyar'},
    { value: Locales.PT, caption: 'Portugese - português'},
    { value: Locales.RU, caption: 'Russian - русский'},
    // { value: Locales.JA, caption: 'Japanese - 日本語'},
    // { value: Locales.TH, caption: 'Thai - ไทย'},
    // { value: Locales.ID, caption: 'Indonesian - Indonesia'},
    {value: Locales.CS, caption: 'Czech - čeština'}
]
